import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
// import ProjectBasedItemsWidget from '../../../../widgets/projectBasedItemsWidget/ProjectBasedItemsWidget'
import FinancialReportsDeliveredWidget from '../../../../widgets/financialReportsDeliveredWidget/FinancialReportsDeliveredWidget'
import '../../styles.less'
import { getFinancialReportsDeliveredPage } from '../../../../redux/actions/financialReportsDelivered'
import { sessionGetItemStr } from '../../../../utils/sessionHelpers'

export default function FinancialReportsDelivered() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getFinancialReportsDeliveredPage(projectCode)
      setSchema(_schema)
      console.log('_schema', _schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <FinancialReportsDeliveredWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}
